'use strict';

angular.module('lingApp')
  .directive('ripResetPassword', function ($window, i18n, RipServer) {
    return {
      template: require('views/rip-reset-password.html'),
      restrict: 'E',
      scope: { initial: '@' },
      link: function postLink(scope, element, attrs) {
        scope.error = {};
        scope.record = {};
        scope.submit = submit;
        scope.submitting = false;

        function submit() {
          if (scope.submitting) return;
          scope.submitting = true;

          if (!validate()) {
            scope.submitting = false;
            return;
          }

          RipServer
            .exec('/rip/login/json/resetPassword' + $window.location.search,
                  { newPassword: scope.record.password,
                    retypePassword: scope.record.retypePassword })
            .then(function() {
              var location = $window.location;
              $window.location.replace(location.protocol
                                       + '//'
                                       + location.host
                                       + '/rip/launch/home'
                                       + location.search);
            }, function(failure) {
              scope.error.message = ('true' === scope.initial
                                     ? i18n('Failed to set your password')
                                     : i18n('Failed to reset your password'))
                + ':'
                + failure.message;
            });
        }

        function validate() {
          scope.error = {};
          var ok = true;

          if (!scope.record.password) {
            scope.error.password = i18n('Field is required');
            ok = false;
          }

          if (!scope.record.retypePassword) {
            scope.error.retypePassword = i18n('Field is required');
            ok = false;
          }

          if (ok && scope.record.password !== scope.record.retypePassword) {
            scope.error.retypePassword = i18n('passwords do not match');
            ok = false;
          }

          return ok;
        }
      }
    };
  });
